import { Button, FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material";
import { ILayout } from "../../CreateWorkspaces";
import { ArrowBack } from "@mui/icons-material";
import { Title } from "./styled";
import { useState } from "react";

interface IProps {
  title: string;
  layout: ILayout;
  handleUnselectLayout: () => void;
  handleUpdateLayouts: (payload: ILayout, allowed: { title: string, id: string }) => void;
}

export function LayoutSetupConfig({ title, layout, handleUnselectLayout, handleUpdateLayouts }: IProps) {
    const [selectedFormats, setSelectedFormats] = useState<string>("");

    async function handleSave() {
        try {
            // await api.post("/v2/workspaces/create-template", {
            //     workspace,
            //     template,
            // })
            // handleUpdateTemplate({...template, isConfigured: true });
            console.log("KJASHDSA", layout)
            handleUpdateLayouts(layout, { title: `${title} - ${layout.productType}`, id: layout.id })
            handleUnselectLayout();
        } catch (error) {
            //
        }
    }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <IconButton onClick={handleUnselectLayout}>
          <ArrowBack color="primary" />
        </IconButton>
        <Title>{title}</Title>
      </div>
      <div
        style={{
          width: "100%",
          minHeight: "500px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            gap: "22px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              gap: "8px",
            }}
          >
            <div
              style={{
                border: "solid 1px #3024E1",
                borderRadius: "12px",
                padding: "16px",
                backgroundColor: "#3024E10A",
                color: "#3024E1",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              {layout.productType}
            </div>
          </div>
          <FormControl fullWidth style={{ width: "300px" }}>
            <InputLabel id="multiple-select-label-e">Formato de layout</InputLabel>
            <Select
            labelId="multiple-select-label-e"
            // multiple
            value={layout.formats[0]}
            disabled
            // onChange={e => setSelectedFormats([...e.target.value])}
            onChange={e => {
                // console.log(e.target.value)
                setSelectedFormats(e.target.value)
            }}
            >
                {layout.formats.map(format => (
                    <MenuItem value={format}>{format}</MenuItem>
                ))}
                <MenuItem value={"Teste"}>Teste</MenuItem>
            </Select>
        </FormControl>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "8px",
        }}
      >
        <Button
          variant="outlined"
          color="error"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "200px",
          }}
          onClick={handleUnselectLayout}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          style={{
            paddingTop: "0.25rem",
            paddingBottom: "0.25rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: "0.375rem",
            height: "2.5rem",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            fontWeight: 600,
            width: "200px",
          }}
          onClick={handleSave}
        >
          Salvar
        </Button>
      </div>
    </>
  );
}
